import { render, staticRenderFns } from "./CategoryConfiguratorAdvanced.vue?vue&type=template&id=fffe7926&"
import script from "./CategoryConfiguratorAdvanced.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports